
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Alle von der App registrierten Kontakte`}</strong>{` werden benachrichtigt – auch solche,
die Sie nicht persönlich kennen. Jeder Kontakt bekommt eine Meldung mit der
Bitte, eine Hotline zu kontaktieren und sich danach in Quarantäne zu setzen. Die
Kette der Ansteckungen ist somit durchbrochen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;